import React from 'react';
import './MediaMentions.css';

const mentions = [
  {
    tag: 'Newsletter',
    title: "Marketing teams are stuck in single-player Claude mode. Here's how to go multiplayer.",
    description: 'Featured in MKT1\'s breakdown of how marketing teams can move from solo AI use to a shared, collaborative Claude setup.',
    image: 'https://substackcdn.com/image/fetch/$s_!V8px!,w_1200,h_675,c_fill,f_jpg,q_auto:good,fl_progressive:steep,g_auto/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F6cae1555-5808-44c7-a586-1c93a7351ba4_1200x630.png',
    url: 'https://newsletter.mkt1.co/p/multiplayer-claude-1',
  },
  {
    tag: 'Podcast',
    title: 'A guide to data transformation and building a warehouse-first martech stack',
    description: 'On the Humans of MarTech podcast, discussing how marketers can bridge the gap with data teams using SQL and dbt.',
    image: 'https://i0.wp.com/humansofmartech.com/wp-content/uploads/2024/10/episode-featured-images-101-200-5-min-1-2.png?fit=3372%2C886&ssl=1',
    url: 'https://humansofmartech.com/2024/10/29/143-danny-lambert-building-warehouse-first-martech/',
  },
  {
    tag: 'Podcast',
    title: 'The Fall of CRM Gravity (The Dungeon of Martech Architecture, Part 1)',
    description: 'A return to Humans of MarTech to make the case for warehouse-first architecture over CRM-as-source-of-truth.',
    image: 'https://humansofmartech.com/wp-content/uploads/2026/06/episode-featured-images-201-300-6.png',
    url: 'https://humansofmartech.com/2026/06/23/225-fall-of-crm-gravity-dungeon-of-martech-architecture-part-1/',
  },
  {
    tag: 'Talk',
    title: 'dbt Labs on dbt — Coalesce 2023 (Sydney)',
    description: 'A talk from Coalesce 2023 on how dbt Labs uses dbt internally to power its own marketing and GTM data.',
    image: 'https://img.youtube.com/vi/3h4k-YVUWO0/hqdefault.jpg',
    url: 'https://www.youtube.com/watch?v=3h4k-YVUWO0',
  },
];

const MediaMentions = () => {
  return (
    <section className="media-section" id="media">
      <div className="media-intro">
        <h2>Featured In</h2>
        <p>
          Newsletters, podcasts, and talks where I've shared thinking on martech,
          data, and GTM engineering.
        </p>
      </div>

      <div className="media-grid">
        {mentions.map((mention, index) => (
          <a
            className="media-card"
            key={index}
            href={mention.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="media-card-image">
              <img src={mention.image} alt={mention.title} loading="lazy" />
              <span className="media-tag">{mention.tag}</span>
            </div>
            <div className="media-card-body">
              <h3>{mention.title}</h3>
              <p>{mention.description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default MediaMentions;
